import BaseTabs from 'components/atoms/base-tabs';
import { BoardType } from 'infrastructure/enums';
import { useOverviewDashboardFilter } from 'infrastructure/hooks/rpm/overview-dashboard';
import useUser from 'utils/useUser';

import type { FC } from 'react';

const tabs = [
  { key: BoardType.RN, label: 'RN' },
  { key: BoardType.MA, label: 'MA' },
];

const BoardTypeToggle: FC = () => {
  const { isSupervisorRole } = useUser();
  const { filter, updateFilter } = useOverviewDashboardFilter();

  if (!isSupervisorRole) return null;

  return (
    <BaseTabs
      tabs={tabs}
      activeKey={filter.boardType ?? BoardType.RN}
      type="rounded"
      size="small"
      onChange={(tab) => updateFilter({ boardType: tab.key, page: undefined })}
    />
  );
};

export default BoardTypeToggle;
